module.exports = __webpack_public_path__ + "static/media/Ulysses S. Grant - 1868.7e2d97c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Ulysses S. Grant - 1868.jpg
// module id = 559
// module chunks = 0